import { render } from "./RedaccionesComponent.vue?vue&type=template&id=c565e5c0&scoped=true"
import script from "./RedaccionesComponent.vue?vue&type=script&lang=js"
export * from "./RedaccionesComponent.vue?vue&type=script&lang=js"

import "./RedaccionesComponent.vue?vue&type=style&index=0&id=c565e5c0&scoped=true&lang=css"

import exportComponent from "/Users/norberto/Documents/Marketing HL/adminmkthl/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c565e5c0"]])

export default __exports__